import { App } from 'vue';

function ensureAnchorId(anchor?: string): string | undefined {
    // replace # in id to avoid id="#my-element" that makes the selector $$('#\#my-element')
    return anchor ? CSS.escape(anchor.replace('#', '')) : undefined;
}

export default function config(app: App) {
    app.config.globalProperties.$anchorFilter = ensureAnchorId;
}
